var _rect, _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconOtherApps(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 8,
    fill: "#F3F4F6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.5 12H14.6667C13.1939 12 12 13.1939 12 14.6667V20.5C12 21.9728 13.1939 23.1667 14.6667 23.1667H20.5C21.9728 23.1667 23.1667 21.9728 23.1667 20.5V14.6667C23.1667 13.1939 21.9728 12 20.5 12Z",
    fill: "#6B7280"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5 24.8334H14.6667C13.1939 24.8334 12 26.0273 12 27.5V33.3334C12 34.8061 13.1939 36 14.6667 36H20.5C21.9728 36 23.1667 34.8061 23.1667 33.3334V27.5C23.1667 26.0273 21.9728 24.8334 20.5 24.8334Z",
    fill: "#6B7280"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33.3334 12H27.5C26.0273 12 24.8334 13.1939 24.8334 14.6667V20.5C24.8334 21.9728 26.0273 23.1667 27.5 23.1667H33.3334C34.8061 23.1667 36 21.9728 36 20.5V14.6667C36 13.1939 34.8061 12 33.3334 12Z",
    fill: "#6B7280"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M33.3334 24.8334H27.5C26.0273 24.8334 24.8334 26.0273 24.8334 27.5V33.3334C24.8334 34.8061 26.0273 36 27.5 36H33.3334C34.8061 36 36 34.8061 36 33.3334V27.5C36 26.0273 34.8061 24.8334 33.3334 24.8334Z",
    fill: "#6B7280"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconOtherApps);
export default __webpack_public_path__ + "static/media/icon-other-apps.33349e01a1500df1ec6d40346c06a56c.svg";
export { ForwardRef as ReactComponent };